module.exports = __webpack_public_path__ + "static/media/shirts12.6c497b50.jpg";